import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import type { LucideIcon } from "lucide-react";
import { Progress } from "@shared-kernel/primary/shared/shadcn/ui/progress";

interface Step {
  id: number;
  label: string;
  title: string;
  Icon: LucideIcon;
}

interface StepperProps {
  steps: Step[];
  currentStep: number;
  onStepClick: (stepId: number) => void;
}

export const Stepper = ({ steps, currentStep, onStepClick }: StepperProps) => {
  const progress = Math.round(((currentStep + 1) / steps.length) * 100);

  return (
    <div className="rounded px-3 py-2">
      <div className="mb-1 flex items-center text-white">
        <span className="text-xs font-bold">
          Étape {currentStep + 1} sur {steps.length}
        </span>
      </div>
      <div className="relative">
        <Progress value={progress} className="h-1.5 bg-gray-700" indicatorClassName="bg-[#339AF0] duration-500 ease-in-out" />
        <div className="mt-1 flex justify-between gap-1 sm:gap-2">
          {steps.map(step => (
            <div
              key={step.id}
              className={cn(
                "flex flex-1 flex-col items-center gap-1 transition-colors",
                currentStep >= step.id ? "text-[#339AF0] cursor-pointer" : "text-muted-foreground",
              )}
              onClick={() => currentStep >= step.id && onStepClick(step.id)}
            >
              <step.Icon className="size-4 sm:size-5" />
              <div className="max-w-[60px] text-center text-[10px] leading-tight sm:max-w-none sm:text-xs">{step.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
